import { BrandMark } from '@sentinel/web-core';

/** Shown for the few hundred milliseconds of session restore. Structure only, no values. */
export function BootScreen() {
  return (
    <main className="login" aria-busy="true">
      <BrandMark size={64} />
    </main>
  );
}
